import React from 'react';
import { Card, PriceDisplay, Text, Button, Form } from '@heartinternet/hi-ui';
import type { CreditBatch } from '../types';
import { PaypalButton } from './PaypalButton';

interface CreditPricingCardProps {
  batch: CreditBatch;
  /** order-domain-credits.cgi — Buy Now POST target. */
  cgiUrl: string;
  paypalAllowed?: boolean;
}

/**
 * One batch-size pricing card: batch label, batch total, per-domain price, a
 * native Buy Now POST (action=purchase_credits + product_id), and — when the
 * account is paypal_allowed — the PayPal Buy-Now button.
 */
export const CreditPricingCard: React.FC<CreditPricingCardProps> = ({
  batch,
  cgiUrl,
  paypalAllowed,
}) => {
  const itemCount = Number(batch.itemCount) || 0;
  const price = Number(batch.price) || 0;
  const perDomain = itemCount > 0 ? price / itemCount : 0;

  return (
    <Card variant="outlined" className="hi-ui-order-domain-credits-page__card">
      <div className="hi-ui-order-domain-credits-page__card-body">
        <Text variant="heading-3" inline className="hi-ui-order-domain-credits-page__card-title">
          {itemCount} credits
        </Text>
        <PriceDisplay amount={price} size="lg" />
        <Text variant="body-small" color="muted" inline>
          £{perDomain.toFixed(2)} per domain
        </Text>
        <Form action={cgiUrl} method="post" className="hi-ui-order-domain-credits-page__buy-form">
          <input type="hidden" name="action" value="purchase_credits" />
          <input type="hidden" name="product_id" value={String(batch.id)} />
          <Button type="submit" variant="primary">
            Buy now
          </Button>
        </Form>
        {paypalAllowed && <PaypalButton productId={batch.id} />}
      </div>
    </Card>
  );
};
